import { render } from "./HomeRenovationCall.vue?vue&type=template&id=3541b569"
import script from "./HomeRenovationCall.vue?vue&type=script&lang=js"
export * from "./HomeRenovationCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__